// extracted by mini-css-extract-plugin
export default {"main_container":"styles-module_main_container_b9dlt8","mainContainer":"styles-module_main_container_b9dlt8"};